import { useMemo } from 'react';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import type { Flow } from '../types';
import { format } from 'date-fns';
import { CellContainer, CellTypography } from '../components/Flows.styles';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useFlowsColumns = (): GridColDef[] => {
  return useMemo(
    () => [
      {
        field: 'name',
        headerName: 'Flow name',
        width: 400,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as Flow).name}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'app',
        headerName: 'Project',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as Flow).app.toUpperCase()}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'call_to_action',
        headerName: 'Call to action',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as Flow).call_to_action}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'default_text',
        headerName: 'Default text',
        width: 340,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as Flow)?.default_text?.text ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'url',
        headerName: 'URL',
        width: 340,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as Flow)?.url ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'created_at',
        headerName: 'Created',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {format(
                new Date((params.row as Flow).created_at),
                'yyyy-MM-dd',
              )}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
    ],
    [],
  );
};
